module.exports = __webpack_public_path__ + "img/ic-facebook.80db22ec.svg";